(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtp-hero-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mtp-video-player')) {
    customElements.define(
      'mtp-video-player',
      class extends HTMLElement {
        connectedCallback() {
          const cover = this.querySelector('[data-mtp-video-cover]');
          const template = this.querySelector('[data-mtp-video-template]');
          if (!cover || !template) return;
          cover.addEventListener('click', () => {
            this.appendChild(template.content.cloneNode(true));
            cover.remove();
            const video = this.querySelector('video');
            if (video) {
              video.muted = false;
              video.volume = 1;
              video.play();
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtp-signup"] && !Shopify.designMode) return;
  try {
    
  // Shopify's newsletter ("customer") form only stores email + tags — it
  // ignores the native First name and Phone fields. So on submit we fold
  // the first name and phone into customer tags ("First name: …", "Phone:
  // …") so the data is captured and exportable. One delegated listener
  // covers every sign-up form on the page (each has the contact[tags]
  // hidden input). Replace with ActionKit/Forms app for native fields.
  if (!window.__mtpSignupCaptureBound) {
    window.__mtpSignupCaptureBound = true;
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || typeof form.querySelector !== 'function') return;
        var tags = form.querySelector('input[name="contact[tags]"]');
        if (!tags) return;
        var extras = [];
        var first = form.querySelector('input[name="contact[first_name]"]');
        var phone = form.querySelector('input[name="contact[phone]"]');
        if (first && first.value.trim()) {
          extras.push('First name: ' + first.value.replace(/,/g, ' ').trim());
        }
        if (phone && phone.value.trim()) {
          extras.push('Phone: ' + phone.value.replace(/,/g, ' ').trim());
        }
        if (extras.length) {
          tags.value = tags.value ? tags.value + ', ' + extras.join(', ') : extras.join(', ');
        }
      },
      true
    );
  }

  // ActionKit SMS opt-in: a phone number is required to subscribe to texts,
  // so make the phone field required whenever the SMS box is checked.
  if (!window.__mtpSmsRequireBound) {
    window.__mtpSmsRequireBound = true;
    document.addEventListener(
      'change',
      function (event) {
        var box = event.target;
        if (!box.matches || !box.matches('input[name="texting_fieldname"]')) return;
        var form = box.closest('form');
        if (!form) return;
        var phone = form.querySelector('input[name="phone"]');
        if (phone) phone.required = box.checked;
      },
      true
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtp-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mtp-video-player')) {
    customElements.define(
      'mtp-video-player',
      class extends HTMLElement {
        connectedCallback() {
          const cover = this.querySelector('[data-mtp-video-cover]');
          const template = this.querySelector('[data-mtp-video-template]');
          if (!cover || !template) return;
          cover.addEventListener('click', () => {
            this.appendChild(template.content.cloneNode(true));
            cover.remove();
            const video = this.querySelector('video');
            if (video) {
              video.muted = false;
              video.volume = 1;
              video.play();
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
